import { InputType } from '@import/enums/input-type.enum';
import { ColumnType } from '@import/interfaces';

export const JobAndPayBankingColumnTypes: ColumnType[] = [
    {
        label: 'Payment Method',
        relatedLabels: ['Payment'],
        serializeName: 'paymentMethod',
        translatableLabel: 'import.columnTypes.paymentMethod',
        input: InputType.options,
        options: [
            {
                label: 'Direct Deposit',
                relatedLabels: ['Direct'],
                translatableLabel: 'import.optionTypes.directDeposit',
                value: 'direct deposit',
            },
            {
                label: 'Cheque',
                relatedLabels: ['Check'],
                translatableLabel: 'import.optionTypes.cheque',
                value: 'cheque',
            },
            {
                label: 'Other',
                translatableLabel: 'import.optionTypes.other',
                value: 'other',
            },
        ],
        required: false,
        requiredWith: ['bankAccounts', 'paymentMethod'],
    },
    {
        label: 'Bank Institution',
        relatedLabels: ['Bank Institution Number', 'Institution Number', 'Bank Institution (3 digits)'],
        translatableLabel: 'import.columnTypes.bankInstitution',
        serializeName: 'bankAccounts.institutionNumber',
        input: InputType.string,
        required: false,
        requiredWith: ['bankAccounts', 'paymentMethod'],
    },
    {
        label: 'Bank Branch',
        relatedLabels: ['Bank Branch Number', 'Branch Number', 'Bank Branch (5 digits)'],
        translatableLabel: 'import.columnTypes.bankBranch',
        serializeName: 'bankAccounts.branchNumber',
        input: InputType.string,
        required: false,
        requiredWith: ['bankAccounts', 'paymentMethod'],
    },
    {
        label: 'Bank Account',
        relatedLabels: ['Bank Account Number', 'Account Number', 'Bank Account (7 - 12 digits)'],
        translatableLabel: 'import.columnTypes.bankAccount',
        serializeName: 'bankAccounts.accountNumber',
        input: InputType.string,
        required: false,
        requiredWith: ['bankAccounts', 'paymentMethod'],
    },
];
